<template>
  <div id="LocationSupportComponent" class="category-layout">
    <v-card outlined
      ><v-card-title>{{ $t("vendor.headerStep3") }}</v-card-title
      ><v-card-text
        ><v-form ref="form" v-model="valid" lazy-validation>
          <v-row align="start" class="pa-4">
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="vendorLocationModel.countryId"
                :items="country"
                :rules="[(v) => !!v || 'Country is required']"
                :label="$t('vendor.country')"
                required
                item-text="countryName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="4" v-if="vendorLocationModel.countryId == '221'">
              <v-select
                outlined
                dense
                v-model="vendorLocationModel.provinceId"
                :items="province"
                :rules="[(v) => !!v || 'Province is required']"
                label="Province (เลือกจังหวัด)"
                required
                item-text="provinceName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="2">
              <v-btn @click="addVendorLocation" class="primary">
                Add Location
              </v-btn></v-col
            ></v-row
          ></v-form
        >
        <v-data-table :headers="headers" :items="showTable"
          ><template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              @click="
                deleteVendorLocation({
                  countryId: item.countryId,
                  provinceId: item.provinceId,
                })
              "
            >
              mdi-delete
            </v-icon>
          </template></v-data-table
        ></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
export default {
  name: "CategoryComponent",
  props: {
    propUserName: {
      type: String,
      default: "",
    },
    propVendorID: {
      type: Number,
      default: 0,
    },
    propVendorLocationList: {
      type: Array,
      default: () => [],
    },
    propProvince: {
      type: Array,
      default: () => [],
    },
    propCountry: {
      type: Array,
      default: () => [],
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  data: () => ({
    vendorLocationModel: {
      vendorId: 0,
      userName: "",
      countryId: 0,
      provinceId: 0,
    },
    vendorLocationList: [],
    country: [],
    province: [],
    userName: "",
    vendorId: 0,
    showTable: [],
    headers: [
      { text: "Country", value: "countryName" },
      { text: "Province", value: "provinceName" },
      { text: "Delete", value: "actions", sortable: false },
    ],
    valid: true,
  }),
  watch: {
    propCountry(value) {
      if (value) this.country = value;
    },
    propProvince(value) {
      if (value) this.province = value;
    },
    propVendorLocationList(value) {
      if (value) this.vendorLocationList = value;
    },
    propUserName(value) {
      if (value) this.userName = value;
    },
    propVendorID(value) {
      if (value) this.vendorId = value;
    },
    vendorLocationList(value) {
      this.showTable = this.newData(value);
    },
    propCheckStep(value) {
      if (value === 3) {
        if (this.showTable.length > 0) {
          this.$emit("EmitLocationNext", true);
        } else {
          this.$notify({
            title: "Cann't goto next step!",
            text: "Please specify at least one location.",
            type: "error",
          });
        }
      }
    },
  },
  async mounted() {
    this.showTable = await this.newData(this.vendorLocationList);
  },
  methods: {
    newData(data) {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isActive) {
          const element = {
            ...data[i],
          };
          result.push(element);
        }
      }
      return result;
    },
    async addVendorLocation() {
      await this.$refs.form.validate();
      if (this.userName !== "") {
        if (
          (this.vendorLocationModel.countryId == 221 &&
            this.vendorLocationModel.provinceId == 0) ||
          this.vendorLocationModel.countryId == 0
        ) {
          this.$notify({
            title: "Can't add location!",
            text: "Please select country or province before",
            type: "error",
          });
        } else {
          const dupCountry = this.vendorLocationList.find(
            (element) =>
              element.countryId === this.vendorLocationModel.countryId
          );
          let dupProvince = undefined;
          if (dupCountry !== undefined) {
            if (dupCountry.countryId === 221) {
              dupProvince = this.vendorLocationList.find(
                (element) =>
                  element.provinceId === this.vendorLocationModel.provinceId
              );
              if (dupProvince === undefined) {
                await this.emitLocation();
                this.vendorLocationModel.countryId = 0;
                this.vendorLocationModel.provinceId = 0;
              } else {
                for (let i = 0; i < this.vendorLocationList.length; i++) {
                  if (
                    this.vendorLocationList[i].countryId ===
                    this.vendorLocationModel.countryId
                  ) {
                    if (this.vendorLocationList[i].countryId === 221) {
                      if (
                        this.vendorLocationList[i].provinceId ===
                        this.vendorLocationModel.provinceId
                      ) {
                        if (this.vendorLocationList[i].isActive) {
                          this.$notify({
                            title: "Cann't add this location!",
                            text: "This location was duplicated.",
                            type: "error",
                          });
                        } else {
                          this.$emit("EmitLocation", {
                            TypeEvent: "update",
                            model: null,
                            countryId: this.vendorLocationModel.countryId,
                            provinceId: this.vendorLocationModel.provinceId,
                          });
                        }
                      }
                    }
                  }
                }
              }
            } else {
              for (let i = 0; i < this.vendorLocationList.length; i++) {
                if (
                  this.vendorLocationList[i].countryId ===
                  this.vendorLocationModel.countryId
                ) {
                  if (this.vendorLocationList[i].isActive) {
                    this.$notify({
                      title: "Cann't add this location!",
                      text: "This location was duplicated.",
                      type: "error",
                    });
                  } else {
                    this.$emit("EmitLocation", {
                      TypeEvent: "update",
                      model: null,
                      countryId: this.vendorLocationModel.countryId,
                      provinceId: 0,
                    });
                  }
                }
              }
            }
          } else {
            await this.emitLocation();
            await this.$refs.form.reset();
            // this.vendorLocationModel.countryId = null;
            // this.vendorLocationModel.provinceId = null;
          }
        }
      } else {
        this.$notify({
          title: "Can't add location!",
          text: "Please input TaxID before",
        });
      }
    },
    async deleteVendorLocation({ countryId, provinceId }) {
      if (!provinceId) provinceId = 0;
      this.$emit("EmitLocation", {
        TypeEvent: "delete",
        model: null,
        countryId,
        provinceId,
      });
    },
    async emitLocation() {
      const findCountry = this.country.find(
        (element) => element.id === this.vendorLocationModel.countryId
      );

      const findProvince =
        this.vendorLocationModel.countryId == 221
          ? this.province.find(
              (element) => element.id === this.vendorLocationModel.provinceId
            )
          : { id: 0, provinceName: null };

      const model = {
        id: 0,
        vendorId: this.vendorId,
        userName: this.userName,
        countryId: findCountry.id,
        provinceId: findProvince.id,
        countryName: findCountry.countryName,
        provinceName: findProvince.provinceName,
        isActive: true,
      };

      this.$emit("EmitLocation", { TypeEvent: "add", model });
    },
  },
};
</script>
